export const COMPONENT_NAME = "forgot-password";
